import { useEffect, useState } from "react";

interface SvgLoaderProps {
  fileName: string;
}

function SvgLoader({ fileName }: SvgLoaderProps) {
  const [svgContent, setSvgContent] = useState<string>("");

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/" + fileName)
      .then(res => res.text())
      .then(svg => {
        let coloredSvg = svg;
        setSvgContent(coloredSvg);
      });
  },[]);

  return <div dangerouslySetInnerHTML={{ __html: svgContent }} />;
}

export default SvgLoader;
